import { useLocation } from "react-router-dom";
import CustomerSimplifiedDTO from "features/customer/dtos/CustomerSimplifiedDTO";
import { useEffect, useState } from "react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IRepository from "data/IRepository";
import DataQuery from "data/DataQuery";
import { Customer_GetSimplified } from "data/endpoints";
import { getQueryParams } from "features/shared/helpers/queryParams";

export const useCustomerSimplified = (
  customerId: string,
  forAdminUse: boolean = false
): { customer: CustomerSimplifiedDTO } => {
  // DI
  const customerRepo = useInjection<IRepository<CustomerSimplifiedDTO>>(
    IocTypes.Repository
  );

  // router
  const { state: customerLocation } = useLocation<CustomerSimplifiedDTO>();

  // state
  const [customer, setCustomer] = useState(customerLocation);

  // side-effects
  useEffect(() => {
    if (customerLocation) {
      setCustomer(customerLocation);
    } else {
      fetchAndSetCustomer();
    }
  }, []);

  // helpers
  const getCustomerQueryParams = () => {
    let queryParams = getQueryParams("CustomerId", customerId);
    if (forAdminUse) {
      queryParams.set("ForAdminUse", String(true))
    }

    return queryParams;
  }

  const fetchAndSetCustomer = async () => {
    const query: DataQuery = {
      url: Customer_GetSimplified,
      params: getCustomerQueryParams()
    };

    let customers = await customerRepo.getPagedResult(query);

    if (customers?.count === 1) {
      setCustomer(customers.result[0]);
    }
  };

  // return
  return { customer };
};
